var exports = {
  "k": "xfd349460--1d22e4--container",
  "U": "xfd349460--1d22e4--arrow",
};

module.exports = exports;
